import React, { Component } from "react";
import "./style.scss";
import {
  getCommonApi,
  commonCreateApi,
  commonPatchApi,
  commonUpdateApi,
} from "redux/actions/common";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";
import { Toast } from "service/toast";
import _ from "lodash";
import { TreatmentModal } from "./AppointmentTable";
export class AppointmentFormClass extends Component {
  constructor(props) {
    super(props);

    const { appointmentData, selectedDate, selectedTime, selectedStaffId } =
      props;

    this.state = {
      formData: {
        mode: "create",
        date: appointmentData?.date || selectedDate || "",
        customerId: appointmentData?.customerId || "",
        customerName: appointmentData?.customerName || "",
        status: appointmentData?.status || "Booking",
        startTime: appointmentData?.startTime || selectedTime || "",
        endTime: appointmentData?.endTime || "",
        service: appointmentData?.service || "",
        slot: appointmentData?.slot || "",
        duration: appointmentData?.duration || "01:00",
        staffId: appointmentData?.staffId || selectedStaffId || "",
        serviceName: appointmentData?.serviceName || "",
        checktype: "",
        requestedTherapist: appointmentData?.requestedTherapist || false,
        custPhone: "",
        custRefer: "",
      },
      showCustomerTable: false,
      filteredCustomers: [],
      searchQuery: appointmentData?.customerName || "",
      showWalkInForm: false,
      apptId: null,
      walkInData: {
        name: "",
        phone: "",
        reference: "",
      },
      errors: {},
      bookingList: [],
      isOpenModal: false,
      treatmentField: {
        category: "",
        treatment: "",
      },
      categoryList: [],
      selectTreatmentId: "",
      treatmentListHeader: [
        { label: "Service", className: "w-75" },
        { label: "Duration", className: "w-25" },
        {
          label: "price",
          className: "w-50",
          divClass: "justify-content-end text-right",
        },
      ],
      treatmentList: [],
      meta: {},
      settingData: {},
      freeTextStockId: "",
      search: "",
      isWalkin: false,
      durationList: [],
      isTreatementModal: false,
      treatmentPackageList: [],
      cust_data: {},
      isUpcomingModal: false,
      isHistoryModal: false,
    };

    this.tableRef = React.createRef();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.selectedTime !== this.props.selectedTime) {
      this.setState(
        (prevState) => ({
          formData: {
            ...prevState.formData,
            startTime: this.props.selectedTime || "",
          },
        }),
        () => {
          this.calculateEndTime();
        }
      );
    }
    if (prevProps.selectedDate !== this.props.selectedDate) {
      this.setState((prevState) => ({
        formData: {
          ...prevState.formData,
          date: this.props.selectedDate || "",
        },
      }));
      console.log(this.props.selectedDate, "Select");
    }
    if (prevProps.selectedStaffId !== this.props.selectedStaffId) {
      this.setState((prevState) => ({
        formData: {
          ...prevState.formData,
          staffId: this.props.selectedStaffId || "",
        },
      }));
    }
  }
  componentDidMount() {
    this.search({});
    this.calculateEndTime();
    let { categoryList, durationList } = this.state;
    document.addEventListener("mousedown", this.handleClickOutside);
    this.props.getCommonApi("bookingstatus/").then((res) => {
      let { status, data, sec_data } = res;
      console.log(data);
      if (status === 200) {
        this.setState({ bookingList: data, secStatusList: sec_data });
      }
    });
    this.props.getCommonApi(`itemdept/`).then((key) => {
      let { status, data } = key;
      if (status === 200) {
        for (let value of data) {
          categoryList.push({ value: value.id, label: value.itm_desc });
        }
        this.setState({ categoryList });
      }
    });

    this.props.getCommonApi(`treatment/Duration/`).then((key) => {
      let { status, data } = key;
      if (status === 200) {
        for (let value of data) {
          durationList.push({ value: value, label: value });
        }
        this.setState({ durationList });
      }
    });
    this.handleItemSettings();
    this.getFreetextStockid();
  }

  loadAppointmentData = (appointmentData, settingData) => {
    if (!appointmentData || !appointmentData.appt_id) return;
    console.log(appointmentData, "Appointment");
    this.props
      .getCommonApi(
        `appointmentedit/${appointmentData.appt_id}/?site_select=${settingData?.logined_siteid}`
      )
      .then(async (key) => {
        let { status, data } = key;
        if (status === 200) {
          if (data.treatment) {
            this.setState({
              mode: "edit",
              formData: {
                date: this.formatDateForInput(appointmentData.startDate),
                customerId: appointmentData.cust_id,
                customerName: appointmentData.cust_name,
                custPhone: data?.appointment?.cust_phone1,
                custRefer: data?.appointment?.cust_refer,
                status: appointmentData.status,
                startTime: data?.treatment[0]?.start_time,
                endTime: data?.treatment[0]?.end_time,
                service: data?.treatment[0]?.item_id || "",
                serviceName:
                  appointmentData.text || appointmentData.appt_remark,
                slot: appointmentData.room || "",
                duration: data?.treatment[0]?.add_duration,
                staffId: data?.treatment[0]?.emp_id || "",
                staffName: appointmentData.staff,
                checktype: data?.treatment[0]?.checktype || "",
                requestedTherapist:
                  data?.treatment[0]?.requesttherapist || false,
              },
              searchQuery: appointmentData.cust_name,
              apptId: appointmentData.appt_id,
              appointmentRecordId: appointmentData.id,
              isWalkin: appointmentData.walkin,
            });
          }
        }
      });
  };

  getPackageList = (data) => {
    let { page = 1, limit = 10 } = data;
    const { formData } = this.state;

    this.props
      .getCommonApi(
        `treatmentpackages/?cust_id=${formData?.customerId}&page=${page}&limit=${limit}`
      )
      .then((res) => {
        console.log(res, "treatmentpackagelistresponse");
        let { status, data, cust_data } = res;
        if (status === 200) {
          if (data) {
            let cust = {};
            cust["cust_name"] = cust_data?.cust_name;
            cust["cust_refer"] = cust_data?.cust_refer;
            this.setState({
              treatmentPackageList: res.data.dataList || [],
              packageMeta: res.data.meta?.pagination || {},
              cust_data: cust,
            });
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching packages:", error);
        this.setState({
          treatmentPackageList: [],
        });
      });
  };

  getFreetextStockid = (async) => {
    let { selectTreatmentId } = this.state;
    let page = 1,
      limit = 10;
    this.props
      .getCommonApi(
        `stocklist/?Item_Deptid=${selectTreatmentId}&search=&page=${page}&limit=${limit}`
      )
      .then((res) => {
        let { data, status } = res;
        if (status === 200) {
          if (data && data.stock_id && data.stock_id !== " ") {
            this.setState({ freeTextStockId: data.stock_id });
          } else {
            Toast({
              type: "error",
              message: "Stock Id not found for free text item",
            });
          }
        }
      });
  };

  handleItemSettings = () => {
    let { settingData } = this.state;
    this.props.getCommonApi(`userlist/`).then((key) => {
      let { status, data } = key;
      console.log(key, "settingsData appointmentCreate");
      if (status === 200) {
        settingData = data;
        this.setState({ settingData });
        this.loadAppointmentData(this.props.selectedAppointment, settingData);
      }
    });
  };

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (
      this.tableRef.current &&
      !this.tableRef.current.contains(event.target)
    ) {
      this.setState({ showCustomerTable: false });
    }
  };

  handleInputChange = (field, value) => {
    console.log(value, "value");
    this.setState(
      (prevState) => ({
        formData: {
          ...prevState.formData,
          [field]: value,
        },
        errors: {
          ...prevState.errors,
          [field]: "",
        },
      }),
      () => {
        if (field === "startTime") {
          let getStartTime = value?.split(":")[0];
          this.props.handleSelectedHour(getStartTime);
        }
        if (field === "startTime" || field === "duration") {
          this.calculateEndTime();
        }
      }
    );
  };

  // Format date from "2025-10-23T09:00:00.0000000" to "2025-10-23"
  formatDateForInput = (dateString) => {
    if (!dateString) return "";

    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "";

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return "";
    }
  };

  // Extract time from "2025-10-23T09:00:00.0000000" to "09:00"
  extractTimeFromDate = (dateTimeString) => {
    if (!dateTimeString) return "";

    try {
      if (
        typeof dateTimeString === "string" &&
        /^\d{2}:\d{2}$/.test(dateTimeString)
      ) {
        return dateTimeString;
      }

      const date = new Date(dateTimeString);
      if (isNaN(date.getTime())) return "";

      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      return `${hours}:${minutes}`;
    } catch (error) {
      console.error("Error extracting time:", error);
      return "";
    }
  };

  // Calculate duration from two datetime strings in HH:MM format
  calculateDurationFromDates = (startDateString, endDateString) => {
    if (!startDateString || !endDateString) return "01:00";

    try {
      const startDate = new Date(startDateString);
      const endDate = new Date(endDateString);

      if (isNaN(startDate.getTime()) || isNaN(endDate.getTime()))
        return "01:00";

      const durationMs = endDate - startDate;
      const durationMinutes = Math.floor(durationMs / 60000);

      if (durationMinutes <= 0) return "01:00";

      const hours = Math.floor(durationMinutes / 60);
      const minutes = durationMinutes % 60;

      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0"
      )}`;
    } catch (error) {
      console.error("Error calculating duration:", error);
      return "01:00";
    }
  };

  selectCustomerFromTable = (customer) => {
    this.setState({
      formData: {
        ...this.state.formData,
        customerId: customer.id,
        customerName: customer.cust_name,
        custPhone: customer?.cust_phone2,
        custRefer: customer?.cust_refer,
      },
      isWalkin: false,
      searchQuery: customer.cust_name,
      showCustomerTable: false,
      showWalkInForm: false,
      errors: {
        ...this.state.errors,
        customerName: "",
      },
    });
  };

  handleAddNewCustomer = () => {
    this.setState({
      showWalkInForm: !this.state.showWalkInForm,
      showCustomerTable: false,
      formData: {
        ...this.state.formData,
        customerId: "",
        customerName: "",
      },
      searchQuery: "",
    });
  };

  handleWalkInChange = (field, value) => {
    this.setState((prevState) => ({
      walkInData: {
        ...prevState.walkInData,
        [field]: value,
      },
      errors: {
        ...prevState.errors,
        [`walkin_${field}`]: "",
      },
    }));
  };

  calculateEndTime = () => {
    const { startTime, duration } = this.state.formData;
    if (startTime && duration) {
      const [startHours, startMinutes] = startTime.split(":").map(Number);

      const [durationHours, durationMinutes] = duration.split(":").map(Number);

      const startTotalMinutes = startHours * 60 + startMinutes;
      const durationTotalMinutes = durationHours * 60 + durationMinutes;
      const endTotalMinutes = startTotalMinutes + durationTotalMinutes;

      const endHours = Math.floor(endTotalMinutes / 60);
      const endMinutes = endTotalMinutes % 60;

      const formattedEndTime = `${endHours
        .toString()
        .padStart(2, "0")}:${endMinutes.toString().padStart(2, "0")}`;

      this.setState((prevState) => ({
        formData: {
          ...prevState.formData,
          endTime: formattedEndTime,
        },
      }));
    }
  };
  getTimeRange = () => {
    const { startDayHour = 8, endDayHour = 21 } = this.props;

    return {
      min: `${startDayHour.toString().padStart(2, "0")}:00`,
      max: `${endDayHour.toString().padStart(2, "0")}:00`,
    };
  };

  formatTimeDisplay = (timeString) => {
    const [hours, minutes] = timeString.split(":").map(Number);

    const period = hours >= 12 ? "PM" : "AM";
    const displayHours = hours > 12 ? hours - 12 : hours === 0 ? 12 : hours;

    return `${displayHours}:${minutes.toString().padStart(2, "0")} ${period}`;
  };

  validateForm = () => {
    const errors = {};
    const { formData, showWalkInForm, walkInData } = this.state;
    const { startDayHour = 8, endDayHour = 21 } = this.props;

    if (!formData.startTime) {
      errors.startTime = "Start time is required";
    } else {
      const [startHours, startMinutes] = formData.startTime
        .split(":")
        .map(Number);
      const startTimeInMinutes = startHours * 60 + startMinutes;
      const businessStartMinutes = startDayHour * 60;
      const businessEndMinutes = endDayHour * 60;

      if (
        startTimeInMinutes < businessStartMinutes ||
        startTimeInMinutes >= businessEndMinutes
      ) {
        const { min, max } = this.getTimeRange();
        errors.startTime = `Time must be between ${this.formatTimeDisplay(
          min
        )} and ${this.formatTimeDisplay(max)}`;
      } else if (formData.duration) {
        const [durationHours, durationMinutes] = formData.duration
          .split(":")
          .map(Number);
        const durationInMinutes = durationHours * 60 + durationMinutes;
        const endTimeInMinutes = startTimeInMinutes + durationInMinutes;

        if (endTimeInMinutes > businessEndMinutes) {
          const { max } = this.getTimeRange();
          errors.startTime = `Appointment with ${
            formData.duration
          } duration would end after business hours (${this.formatTimeDisplay(
            max
          )})`;
        }
      }
    }

    if (!formData.service) errors.service = "Service is required";
    if (!formData.status) errors.status = "Status is required";
    if (!formData.duration) errors.duration = "Duration is required";

    if (!formData.customerName.trim())
      errors.customerName = "Customer name is required";

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  validateWalkinForm = () => {
    const errors = {};
    const { walkInData } = this.state;
    if (!walkInData.name.trim()) errors.walkin_name = "Name is required";
    if (!walkInData.phone.trim()) errors.walkin_phone = "Phone is required";
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (!this.validateForm()) {
      return;
    }

    const { formData, showWalkInForm, walkInData, settingData, isWalkin } =
      this.state;
    let { selectedAppointment } = this.props;
    let payload = {
      Appointment: {
        appt_date: formData?.date,
        Appt_typeid: "",
        cust_noid: formData?.customerId,
        new_remark: "",
        Source_Codeid: "",
        Room_Codeid: "",
        appt_status: formData?.status,
        sec_status: "",
        ItemSite_Codeid: settingData?.logined_siteid,
        walkin: isWalkin,
        username: "",
        password: "",
        cust_StoreCard: false,
        bookedby: settingData?.username,
        editedby: "",
        maxclasssize: 0,
      },
      Treatment: [
        {
          appt_id: selectedAppointment?.appt_id || "",
          start_time: formData?.startTime,
          end_time: formData?.endTime,
          add_duration: formData?.duration,
          Item_Codeid: formData?.service,
          item_text: formData?.serviceName,
          emp_no: formData?.staffId,
          requesttherapist: formData?.requestedTherapist,
          recur_qty: null,
          recur_days: null,
          checktype: formData?.checktype,
          treat_parentcode: null,
        },
      ],
    };
    let editPayload = {
      appointment: {
        appt_date: formData?.date,
        cust_noid: formData?.customerId,
        Room_Codeid: 0,
        appt_status: formData?.status,
        sec_status: "",
        username: "",
        password: "",
        cust_StoreCard: "",
        bookedby: settingData?.username,
        channel_id: 0,
        apptdel_id: [],
        ori_remark: "",
        edit_remark: "",
        source_id: 0,
        remark_setting: false,
      },
      treatment: [
        {
          appt_id: selectedAppointment?.appt_id || "",
          start_time: formData?.startTime,
          end_time: formData?.endTime,
          add_duration: formData?.duration,
          item_id: formData?.service,
          item_text: formData?.serviceName,
          emp_id: formData?.staffId,
          requesttherapist: formData?.requestedTherapist,
          recur_qty: null,
          recur_days: null,
          checktype: formData?.checktype,
          treat_parentcode: null,
        },
      ],
    };

    if (selectedAppointment?.appt_id) {
      this.props
        .commonPatchApi(
          `appointmentedit/${selectedAppointment?.appt_id}/`,
          editPayload
        )
        .then(async (res) => {
          this.props.handleCloseDialog();
          this.props.getAppointmentWithStaff();
        })
        .catch((err) => {
          console.log(err, "error");
        });
    } else {
      this.props
        .commonCreateApi(`appointment/`, payload)
        .then(async (res) => {
          if (res.status === 201) {
            this.props.handleCloseDialog();
            this.props.getAppointmentWithStaff();
          }
        })
        .catch((err) => {
          console.log(err, "error");
        });
    }
  };

  handleSearchClick = () => {
    let { searchQuery } = this.state;
    let { basicApptDetail } = this.props;
    this.props
      .getCommonApi(
        `custappt/?Outlet=${
          basicApptDetail.branchId ? basicApptDetail.branchId : ""
        }&search=${searchQuery}`
      )
      .then((key) => {
        let { status, data } = key;
        if (status === 200) {
          this.setState({ showCustomerTable: true, filteredCustomers: data });
        }
      });
  };

  handleWalkinSubmit = () => {
    let { walkInData } = this.state;
    console.log(walkInData, "Walkin");

    if (!this.validateWalkinForm()) {
      return;
    }

    let data = {
      cust_name: walkInData?.name,
      cust_address: null,
      cust_dob: null,
      cust_phone1: null,
      cust_phone2: walkInData?.phone,
      cust_email: null,
      Cust_sexesid: null,
      custallowsendsms: null,
      cust_maillist: null,
      cust_refer: walkInData?.reference,
    };
    this.props.commonCreateApi(`customer/`, data).then(async (res) => {
      if (res.status === 201) {
        console.log(res, "Walkincustomer");
        this.setState({ walkInData: {}, isWalkin: true });
        this.handleWalkInCustomer(res.data);
      } else {
        Toast({ type: "error", message: res.message });
      }
    });
  };

  handleWalkInCustomer = async (data) => {
    let { formData, searchQuery } = this.state;

    formData.customerId = data?.id;
    formData.customerName = data?.cust_name;
    formData.custPhone = data?.cust_phone2;
    formData.custRefer = data?.cust_refer;
    searchQuery = data?.cust_name;
    this.setState({ formData, searchQuery });
    this.setState({
      showWalkInForm: false,
    });
  };

  handleDialog = () => {
    this.setState({ isOpenModal: false, index: null });
  };
  handleTreatmentDialog = () => {
    this.setState({ isTreatementModal: false });
  };

  handleChangeTreatment = async ({ target: { value, name } }) => {
    let { treatmentField, search, selectTreatmentId } = this.state;
    treatmentField[name] = value;
    if (name === "category") {
      selectTreatmentId = value;
    } else if (name === "treatment") {
      search = value;
    }
    await this.setState({
      treatmentField,
      selectTreatmentId,
      search,
    });

    let page = 1,
      limit = 10;
    this.props
      .getCommonApi(
        `stocklist/?Item_Deptid=${selectTreatmentId}&search=${search}&page=${page}&limit=${limit}`
      )
      .then((res) => {
        console.log(res, "stocklis");
        if (res.status === 200) {
          this.setState({
            treatmentList: res.data.dataList,
            meta: res.data.meta.pagination,
          });
        }
      });
  };

  handleSearch = (event) => {
    event.persist();
    console.log(event.target.value, event.target, event, "dfhdfjghkjfghj");
    let { treatmentField } = this.state;
    treatmentField["treatment"] = event.target.value;
    this.setState({ search: event.target.value, treatmentField });
    if (!this.debouncedFn) {
      this.debouncedFn = _.debounce(() => {
        let searchString = event.target.value;
        let data = { search: searchString };
        this.search(data);
      }, 500);
    }
    this.debouncedFn();
  };

  search = (data) => {
    let { page = 1, limit = 10, search = "" } = data;
    let { selectTreatmentId } = this.state;
    this.props
      .getCommonApi(
        `stocklist/?Item_Deptid=${selectTreatmentId}&search=${search}&page=${page}&limit=${limit}`
      )
      .then((res) => {
        console.log(res, "treatmentList treatment_parentcode");
        if (res.status === 200) {
          this.setState({
            treatmentList: res.data.dataList,
            meta: res.data.meta.pagination,
          });
        }
      });
  };

  handlePagination = (page) => {
    this.search(page);
  };

  handleSelectTreatment = async (data) => {
    let { formData } = this.state;

    formData.service = data.id;
    formData.serviceName = data.item_desc;
    formData.duration = data.add_duration;
    formData.checktype = "service";
    await this.setState({
      formData,
      isOpenModal: false,
    });

    this.calculateEndTime();
  };

  handleFreeTextChange = ({ target: { value, name } }) => {
    let { formData, freeTextStockId } = this.state;
    console.log(value, "value");
    formData.service = freeTextStockId;
    formData.serviceName = value;
    formData.checktype = "freetext";
    this.setState({
      formData,
    });
  };

  // Helper method to convert duration format (HH:MM) to minutes
  convertDurationToMinutes = (duration) => {
    if (!duration) return "60";

    const parts = duration.split(":");
    if (parts.length === 2) {
      const hours = parseInt(parts[0]) || 0;
      const minutes = parseInt(parts[1]) || 0;
      return (hours * 60 + minutes).toString();
    }

    return "60";
  };

  // Helper method to convert minutes to duration format (HH:MM)
  convertMinutesToDuration = (totalMinutes) => {
    const minutes = parseInt(totalMinutes, 10);
    if (isNaN(minutes) || minutes < 0) return "00:00";

    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;

    const paddedHours = hours.toString().padStart(2, "0");
    const paddedMinutes = mins.toString().padStart(2, "0");

    return `${paddedHours}:${paddedMinutes}`;
  };

  handleTreatementmodal = () => {
    let { formData } = this.state;
    let customerId = formData.customerId;
    if (customerId > 0) {
      this.setState(
        (prevState) => ({
          isTreatementModal: !prevState.isTreatementModal,
        }),
        () => {
          if (this.state.isTreatementModal) {
            this.getPackageList({ page: 1, limit: 10 });
          }
        }
      );
    } else {
      Toast({ type: "error", message: "Please select customer" });
    }
  };

  handleUpcomingAppointment = () => {
    let { formData } = this.state;
    let customerId = formData.customerId;
    if (customerId > 0) {
      this.setState((prevState) => ({
        isUpcomingModal: !prevState.isUpcomingModal,
      }));
    } else {
      Toast({ type: "error", message: "Please select customer" });
    }
  };
  handleTreatmentHistory = () => {
    let { formData } = this.state;
    let customerId = formData.customerId;
    if (customerId > 0) {
      this.setState((prevState) => ({
        isHistoryModal: !prevState.isHistoryModal,
      }));
    } else {
      Toast({ type: "error", message: "Please select customer" });
    }
  };

  handleSelectTreatmentPackage = (item) => {
    if (String(item.type).toUpperCase() === "TD") {
      let formFields = {};
      formFields["id"] = item.stock_id;
      formFields["item_desc"] = item.item_name;
      formFields["add_duration"] = item.add_duration;
      formFields["Item_CodeName"] = item.item_name;
      formFields["treatment_parentcode"] = item.treatment_parentcode;

      this.handleSelectPackage(formFields);
    } else {
      Toast({
        type: "error",
        message: "This Package is not allowed",
      });
    }
  };

  handleSelectPackage = async (data) => {
    let { selectedList, formData } = this.state;

    formData.service = data.id;
    formData.serviceName = data.item_desc;
    formData.duration = data.add_duration;
    formData.checktype = "package";
    await this.setState(
      {
        formData,
      },
      () => {
        this.calculateEndTime();
      }
    );

    this.setState({ isTreatementModal: false });
  };

  fetchTreatmentHistory = () => {
    const { formData } = this.state;
    return this.props
      .getCommonApi(
        `appttreatmentdonehistory/?cust_id=${
          formData?.customerId
        }&page=${1}&limit=${10}`
      )
      .then((res) => {
        if (res.status === 200 && res.data) {
          const cardsData = res.data.dataList.map((item, index) => ({
            id: index + 1,
            title: item?.description,
            data: [
              { label: "Date", value: item.date || "-" },
              { label: "Staff", value: item.staff || "-" },
              { label: "Location", value: item.itemsite_code || "-" },
              { label: "Course", value: item.course || "-" },
              { label: "Service Staff", value: item.service_staff || "-" },
              { label: "Txn No.", value: item.helper_transacno || "-" },
              { label: "Remark", value: item.new_remark || "-" },
            ],
          }));
          return cardsData;
        }
        return [];
      });
  };

  handleSelectHistory = (item) => {
    console.log("Selected history:", item);
    this.setState({ isHistoryModal: false });
  };

  renderHistoryRow = (item) => {
    return (
      <>
        <td>
          <div className="text-left">{item.description}</div>
        </td>
        <td>
          <div className="text-left">{item.date}</div>
        </td>
        <td>
          <div className="text-left">{item.staff}</div>
        </td>
        <td>
          <div className="text-center">{item.itemsite_code}</div>
        </td>
        <td>
          <div className="text-left">{item.course}</div>
        </td>
        <td>
          <div className="text-left">{item.service_staff}</div>
        </td>
        <td>
          <div className="text-center">{item.helper_transacno}</div>
        </td>
        <td>
          <div className="text-left">{item.new_remark}</div>
        </td>
      </>
    );
  };

  fetchUpcomingAppointments = () => {
    const { formData } = this.state;
    return this.props
      .getCommonApi(
        `upcomingappointment/?cust_id=${
          formData?.customerId
        }&page=${1}&limit=${10}`
      )
      .then((res) => {
        if (res.status === 200 && res.data) {
          const cardsData = res.data.dataList.map((item, index) => ({
            id: index + 1,
            title: item?.appt_remark,
            data: [
              { label: "Date", value: item.appt_date || "-" },
              { label: "Staff", value: item.emp_name || "-" },
              { label: "Status", value: item.appt_status || "-" },
              { label: "Secondary Status", value: item.sec_status || "-" },
              { label: "Location", value: item.itemsite_code || "-" },
            ],
          }));
          return cardsData;
        }
        return [];
      });
  };

  handleSelectAppointment = (item) => {
    this.setState({ isUpcomingModal: false });
  };

  renderAppointmentRow = (item) => {
    return (
      <>
        <td>
          <div className="text-left">{item.appt_remark}</div>
        </td>
        <td>
          <div className="text-left">{item.appt_date}</div>
        </td>
        <td>
          <div className="text-center">{item.emp_name}</div>
        </td>
        <td>
          <div className="text-center">{item.appt_status}</div>
        </td>
        <td>
          <div className="text-left">{item.sec_status}</div>
        </td>
        <td>
          <div className="text-center">{item.itemsite_code}</div>
        </td>
      </>
    );
  };

  render() {
    const {
      formData,
      searchQuery,
      showCustomerTable,
      filteredCustomers,
      showWalkInForm,
      walkInData,
      errors,
      bookingList,
      selectTreatmentId,
      treatmentField,
      treatmentList,
      categoryList,
      meta,
      isOpenModal,
      settingData,
      durationList,
      isTreatementModal,
      treatmentPackageList,
      cust_data,
      isHistoryModal,
      isUpcomingModal,
    } = this.state;

    const {
      onCancel,
      serviceList = [],
      statusList = [],
      staffList = [],
      selectedAppointment,
    } = this.props;

    const historyHeaders = [
      { label: "Description", divClass: "text-left" },
      { label: "Date", divClass: "text-left" },
      { label: "Staff", divClass: "text-left" },
      { label: "Location", divClass: "text-left" },
      { label: "Course", divClass: "text-left" },
      { label: "Service Staff", divClass: "text-left" },
      { label: "Txn No.", divClass: "text-left" },
      { label: "Remark", divClass: "text-left" },
    ];

    const upcomingHeaders = [
      { label: "Description", divClass: "text-left" },
      { label: "Date", divClass: "text-left" },
      { label: "Staff", divClass: "text-left" },
      { label: "Status", divClass: "text-left" },
      { label: "Secondary Status", divClass: "text-left" },
      { label: "Location", divClass: "text-left" },
    ];

    const defaultStatusList = [
      { value: "scheduled", label: "Scheduled" },
      { value: "confirmed", label: "Confirmed" },
      { value: "completed", label: "Completed" },
      { value: "cancelled", label: "Cancelled" },
      { value: "no-show", label: "No Show" },
    ];

    const customerInfo = {
      name: formData?.customerName || "-",
      reference: formData?.custRefer || "-",
      phone: formData?.custPhone || "-",
    };

    const isEditMode = selectedAppointment?.appt_id;

    return (
      <div className="appointment-form-overlay">
        <div className="appointment-form-container">
          <form onSubmit={this.handleSubmit} className="appointment-form">
            <div className="form-top-actions">
              <div className="top-action-buttons">
                <button
                  type="button"
                  className="btn-top-cancel"
                  onClick={onCancel}
                >
                  Cancel
                </button>
                <button type="submit" className="btn-top-submit">
                  {isEditMode ? "Update" : "Create"}
                </button>
              </div>
            </div>

            {/* Customer Name with Table Search */}
            <div
              className="form-field customer-field-container"
              ref={this.tableRef}
            >
              <div
                className={`field-wrapper ${
                  errors.customerName ? "error" : ""
                }`}
              >
                <svg
                  className="field-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) =>
                    this.setState({ searchQuery: e.target.value })
                  }
                  style={{ width: "100%" }}
                  placeholder="Customer name..."
                  disabled={showWalkInForm || isEditMode}
                />
                {searchQuery && !showWalkInForm && !isEditMode ? (
                  <button
                    type="button"
                    className="action-icon-btn search-btn"
                    onClick={this.handleSearchClick}
                    title="Search customer"
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <circle cx="11" cy="11" r="8" />
                      <path d="M21 21l-4.35-4.35" />
                    </svg>
                  </button>
                ) : !showWalkInForm && !isEditMode ? (
                  <button
                    type="button"
                    className="action-icon-btn add-btn"
                    onClick={this.handleAddNewCustomer}
                    title="Add walk-in customer"
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                      <circle cx="8.5" cy="7" r="4" />
                      <line x1="20" y1="8" x2="20" y2="14" />
                      <line x1="23" y1="11" x2="17" y2="11" />
                    </svg>
                  </button>
                ) : (
                  !isEditMode && (
                    <button
                      type="button"
                      className="action-icon-btn close-walkin-btn"
                      onClick={() => this.setState({ showWalkInForm: false })}
                      title="Close walk-in form"
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                      >
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                      </svg>
                    </button>
                  )
                )}
              </div>
              {errors.customerName && !showWalkInForm && (
                <span className="error-message">{errors.customerName}</span>
              )}

              {/* Customer Table Dropdown */}
              {showCustomerTable && !showWalkInForm && (
                <div className="customer-table-dropdown">
                  <div className="customer-table-wrapper">
                    {filteredCustomers.length > 0 ? (
                      <table className="customer-table">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Phone</th>
                            <th>Reference</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredCustomers?.map((customer) => (
                            <tr
                              key={customer.id}
                              onClick={() =>
                                this.selectCustomerFromTable(customer)
                              }
                              className="customer-row"
                            >
                              <td className="customer-name-col">
                                {customer?.cust_name}
                              </td>
                              <td>{customer?.cust_phone2 || "-"}</td>
                              <td>{customer?.cust_refer || "-"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <div className="no-customers-found">
                        <p>No customers found</p>
                      </div>
                    )}
                  </div>
                  <div className="table-footer">
                    <span className="result-count">
                      {filteredCustomers.length}{" "}
                      {filteredCustomers.length === 1 ? "result" : "results"}
                    </span>
                  </div>
                </div>
              )}
            </div>

            {/* Walk-in Customer Form */}
            {showWalkInForm && (
              <div className="walkin-form">
                <div className="walkin-header">
                  <div className="walkin-title">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                      <circle cx="9" cy="7" r="4" />
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                    <span>Walk-in Customer</span>
                  </div>
                  <button
                    type="button"
                    className="walkin-plus-icon"
                    title="Quick add customer"
                    onClick={this.handleWalkinSubmit}
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <line x1="12" y1="5" x2="12" y2="19" />
                      <line x1="5" y1="12" x2="19" y2="12" />
                    </svg>
                  </button>
                </div>

                <div className="form-field">
                  <div
                    className={`field-wrapper ${
                      errors.walkin_name ? "error" : ""
                    }`}
                  >
                    <svg
                      className="field-icon"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                    >
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                      <circle cx="12" cy="7" r="4" />
                    </svg>
                    <input
                      type="text"
                      value={walkInData.name}
                      onChange={(e) =>
                        this.handleWalkInChange("name", e.target.value)
                      }
                      placeholder="Customer name *"
                    />
                  </div>
                  {errors.walkin_name && (
                    <span className="error-message">{errors.walkin_name}</span>
                  )}
                </div>

                <div className="form-field">
                  <div
                    className={`field-wrapper ${
                      errors.walkin_phone ? "error" : ""
                    }`}
                  >
                    <svg
                      className="field-icon"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                    >
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                    </svg>
                    <input
                      type="tel"
                      value={walkInData.phone}
                      onChange={(e) =>
                        this.handleWalkInChange("phone", e.target.value)
                      }
                      placeholder="Phone number *"
                    />
                  </div>
                  {errors.walkin_phone && (
                    <span className="error-message">{errors.walkin_phone}</span>
                  )}
                </div>

                <div className="form-field">
                  <div className="field-wrapper">
                    <svg
                      className="field-icon"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                    >
                      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                    </svg>
                    <input
                      type="text"
                      value={walkInData.reference}
                      onChange={(e) =>
                        this.handleWalkInChange("reference", e.target.value)
                      }
                      placeholder="Customer Reference"
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Status Field */}
            <div className="form-field">
              <div className={`field-wrapper ${errors.status ? "error" : ""}`}>
                <svg
                  className="field-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                >
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
                <select
                  value={formData?.status}
                  onChange={(e) =>
                    this.handleInputChange("status", e.target.value)
                  }
                >
                  {bookingList?.map((status) => (
                    <option key={status?.value} value={status?.value}>
                      {status?.label}
                    </option>
                  ))}
                </select>
              </div>
              {errors.status && (
                <span className="error-message">{errors.status}</span>
              )}
            </div>

            {/* Start Time Field */}
            <div className="form-field">
              <div
                className={`field-wrapper ${errors.startTime ? "error" : ""}`}
              >
                <svg
                  className="field-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                >
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
                <input
                  type="time"
                  value={formData.startTime}
                  onChange={(e) =>
                    this.handleInputChange("startTime", e.target.value)
                  }
                  placeholder="Start time"
                />
              </div>
              {errors.startTime && (
                <span className="error-message">{errors.startTime}</span>
              )}
            </div>

            {/* Service Field - UPDATED */}
            <div className="form-field">
              <div className={`field-wrapper ${errors.service ? "error" : ""}`}>
                <svg
                  className="field-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                >
                  <path d="M12 2a4 4 0 0 0-4 4v1a4 4 0 0 0-4 4v1a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4v-1a4 4 0 0 0-4-4V6a4 4 0 0 0-4-4z" />
                  <path d="M12 16v6" />
                  <path d="M8 19h8" />
                </svg>
                {settingData &&
                settingData.service_sel &&
                settingData.service_text ? (
                  <input
                    type="text"
                    value={formData.serviceName || ""}
                    placeholder="Select a service..."
                    onChange={(e) => this.handleFreeTextChange(e)}
                    name="service"
                    onDoubleClick={() => this.setState({ isOpenModal: true })}
                    style={{ cursor: "pointer", width: "100%" }}
                  />
                ) : null}
                {settingData &&
                settingData.service_sel &&
                !settingData.service_text ? (
                  <input
                    type="text"
                    value={formData.serviceName || ""}
                    placeholder="Select a service..."
                    onChange={() => {}}
                    name="service"
                    onDoubleClick={() => this.setState({ isOpenModal: true })}
                    style={{ cursor: "pointer", width: "100%" }}
                  />
                ) : null}
                {settingData &&
                !settingData.service_sel &&
                settingData.service_text ? (
                  <input
                    type="text"
                    value={formData.serviceName || ""}
                    placeholder="Select a service..."
                    onChange={(e) => this.handleFreeTextChange(e)}
                    name="service"
                    style={{ cursor: "pointer", width: "100%" }}
                  />
                ) : null}
                {settingData &&
                !settingData.service_sel &&
                !settingData.service_text ? (
                  <input
                    type="text"
                    value={formData.serviceName || ""}
                    placeholder="Select a service..."
                    onChange={() => {}}
                    name="service"
                    style={{ cursor: "pointer", width: "100%" }}
                  />
                ) : null}
              </div>
              {errors.service && (
                <span className="error-message">{errors.service}</span>
              )}
            </div>

            {/* Duration Field */}
            <div className="form-field">
              <div className="field-wrapper">
                <svg
                  className="field-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                >
                  <path d="M12 2v4" />
                  <path d="M12 18v4" />
                  <path d="M7.05 7.05 10 10" />
                  <path d="M14 14l2.95 2.95" />
                  <path d="M7.05 16.95 10 14" />
                  <path d="M14 10l2.95-2.95" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
                <select
                  value={formData.duration}
                  onChange={(e) =>
                    this.handleInputChange("duration", e.target.value)
                  }
                >
                  {durationList?.map((status) => (
                    <option key={status?.value} value={status?.value}>
                      {status?.value}
                    </option>
                  ))}
                  {/* <option value="15">15 minutes</option>
                  <option value="30">30 minutes</option>
                  <option value="45">45 minutes</option>
                  <option value="60">1 hour</option>
                  <option value="90">1.5 hours</option>
                  <option value="120">2 hours</option>
                  <option value="150">2.5 hours</option>
                  <option value="180">3 hours</option> */}
                </select>
              </div>
            </div>

            {/* End Time Field (Read-only) */}
            <div className="form-field">
              <div className="field-wrapper readonly-field">
                <svg
                  className="field-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                >
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                  <line x1="9" y1="9" x2="15" y2="15" />
                  <line x1="15" y1="9" x2="9" y2="15" />
                </svg>
                <input
                  type="time"
                  value={formData.endTime}
                  readOnly
                  placeholder="End time"
                />
              </div>
            </div>

            {/* Staff Field (if multiple staff) */}
            {staffList.length > 0 && (
              <div className="form-field">
                <div className="field-wrapper">
                  <svg
                    className="field-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="7" r="4" />
                    <path d="M5.5 21v-2a6.5 6.5 0 0 1 13 0v2" />
                    {/* Tie/Professional indicator */}
                    <path
                      d="M12 11v4l-1 6h2l-1-6z"
                      fill="currentColor"
                      opacity="0.3"
                    />
                    <path d="M11 11l1-1 1 1" />
                  </svg>
                  <select
                    value={formData.staffId}
                    onChange={(e) =>
                      this.handleInputChange("staffId", e.target.value)
                    }
                  >
                    <option value="">Select therapist</option>
                    {staffList.map((staff) => (
                      <option key={staff.id} value={staff.id}>
                        {staff.staff_name || staff.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            {/* Requested Therapist Checkbox - NEW */}
            <div className="form-field checkbox-field">
              <label className="checkbox-wrapper">
                <input
                  type="checkbox"
                  checked={formData.requestedTherapist || false}
                  onChange={(e) =>
                    this.handleInputChange(
                      "requestedTherapist",
                      e.target.checked
                    )
                  }
                />
                <span className="checkbox-custom">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                </span>
                <span className="checkbox-label">Requested Therapist</span>
              </label>
            </div>
          </form>

          <div className="col-md-12 mt-2">
            <div className="d-flex flex-wrap justify-content-center">
              <button
                onClick={this.handleTreatementmodal}
                className="bottom-btns"
              >
                Package
              </button>
              <button
                onClick={this.handleUpcomingAppointment}
                className="bottom-btns"
              >
                Upcoming Appointment
              </button>
              <button
                onClick={this.handleTreatmentHistory}
                className="bottom-btns"
              >
                Treatment History
              </button>
            </div>
          </div>

          {/* Service Selection Modal */}
          {isOpenModal && (
            <div
              className="treatment-modal-overlay"
              onClick={this.handleDialog}
            >
              <div
                className="treatment-modal-container"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="treatment-modal-header">
                  <h3>Select Service</h3>
                  <button
                    type="button"
                    className="close-modal-btn"
                    onClick={this.handleDialog}
                  >
                    ×
                  </button>
                </div>

                <div className="treatment-filters">
                  <div className="filter-row">
                    <div className="filter-group">
                      <label>Category</label>
                      <div className="field-wrapper">
                        <select
                          value={treatmentField.category}
                          name="category"
                          onChange={this.handleChangeTreatment}
                        >
                          <option value="">Select Category</option>
                          {categoryList.map((cat) => (
                            <option key={cat.value} value={cat.value}>
                              {cat.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="filter-group">
                      <label>Service</label>
                      <div className="field-wrapper">
                        <svg
                          className="search-icon"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                        >
                          <circle cx="11" cy="11" r="8" />
                          <path d="M21 21l-4.35-4.35" />
                        </svg>
                        <input
                          type="text"
                          value={treatmentField.treatment}
                          name="treatment"
                          onChange={this.handleSearch}
                          placeholder="Search service..."
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="treatment-table-wrapper">
                  {treatmentList.length > 0 ? (
                    <table className="treatment-table">
                      <thead>
                        <tr>
                          <th className="text-left">Service</th>
                          <th className="text-center">Duration</th>
                          <th className="text-right">Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        {treatmentList.map((item, index) => (
                          <tr
                            key={index}
                            className="treatment-row"
                            onClick={() => this.handleSelectTreatment(item)}
                          >
                            <td className="text-left treatment-name">
                              {item.item_desc}
                            </td>
                            <td className="text-center">
                              {item.add_duration || "-"}
                            </td>
                            <td className="text-right treatment-price">
                              ${parseFloat(item.item_price || 0).toFixed(2)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div className="no-treatments-found">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                      >
                        <circle cx="11" cy="11" r="8" />
                        <path d="M21 21l-4.35-4.35" />
                      </svg>
                      <p>
                        {treatmentField.category || treatmentField.treatment
                          ? "No treatments found"
                          : "Select category or search to view treatments"}
                      </p>
                    </div>
                  )}
                </div>

                {meta && meta.total > meta.per_page && (
                  <div className="treatment-pagination">
                    <div className="pagination-controls">
                      <button
                        type="button"
                        disabled={Number(meta?.current_page) - 1 === 0}
                        onClick={() =>
                          this.handlePagination({ page: meta.current_page - 1 })
                        }
                        className="pagination-btn"
                      >
                        Previous
                      </button>
                      <span className="page-number">
                        Page {meta.current_page} of {meta.total_pages}
                      </span>
                      <button
                        type="button"
                        disabled={
                          Number(meta.current_page) + 1 > meta?.total_pages
                        }
                        onClick={() =>
                          this.handlePagination({
                            page: Number(meta.current_page) + 1,
                          })
                        }
                        className="pagination-btn"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          <TreatmentModal
            isOpen={isHistoryModal}
            onClose={() => this.setState({ isHistoryModal: false })}
            title="Treatment History"
            headerDetails={historyHeaders}
            customerInfo={customerInfo}
            onFetchData={this.fetchTreatmentHistory}
            onSelectItem={this.handleSelectHistory}
            renderRowCells={this.renderHistoryRow}
            noDataMessage="No treatment history found"
          />

          <TreatmentModal
            isOpen={isUpcomingModal}
            onClose={() => this.setState({ isUpcomingModal: false })}
            title="Upcoming Appointments"
            headerDetails={upcomingHeaders}
            customerInfo={customerInfo}
            onFetchData={this.fetchUpcomingAppointments}
            onSelectItem={this.handleSelectAppointment}
            renderRowCells={this.renderAppointmentRow}
            noDataMessage="No upcoming appointments"
          />

          {isTreatementModal && (
            <div
              className="treatment-modal-overlay"
              onClick={this.handleTreatementmodal}
            >
              <div
                className="treatment-modal-container"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="treatment-modal-header">
                  <h3>Treatment Package</h3>
                  <button
                    type="button"
                    className="close-modal-btn"
                    onClick={this.handleTreatementmodal}
                  >
                    ×
                  </button>
                </div>

                <div className="treatment-filters">
                  <div className="filter-row">
                    <div className="filter-group">
                      <label>Name</label>
                      <div className="field-wrapper">
                        <span className="info-text">
                          {cust_data.cust_name || formData?.customerName || "-"}
                        </span>
                      </div>
                    </div>

                    <div className="filter-group">
                      <label>Reference</label>
                      <div className="field-wrapper">
                        <span className="info-text">
                          {cust_data.cust_refer || formData?.custRefer || "-"}
                        </span>
                      </div>
                    </div>

                    <div className="filter-group">
                      <label>Phone</label>
                      <div className="field-wrapper">
                        <span className="info-text">
                          {formData?.custPhone || "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="treatment-table-wrapper">
                  {treatmentPackageList.length > 0 ? (
                    <table className="treatment-table">
                      <thead>
                        <tr>
                          <th className="text-left">Course</th>
                          <th className="text-left">Tr. #</th>
                          <th className="text-left">Total</th>
                          <th className="text-left">Price</th>
                          <th className="text-left">Expiry Date</th>
                          <th className="text-left">Balance</th>
                          <th className="text-left">Outstanding</th>
                        </tr>
                      </thead>
                      <tbody>
                        {treatmentPackageList.map((item, index) => {
                          let {
                            item_name,
                            tr_open,
                            tr_done,
                            price,
                            expiry,
                            balance,
                            outstanding,
                          } = item;
                          return (
                            <tr
                              key={index}
                              className="treatment-row"
                              onClick={() =>
                                this.handleSelectTreatmentPackage(item)
                              }
                            >
                              <td className="text-left treatment-name">
                                {item_name}
                              </td>
                              <td className="text-center">{tr_open || "-"}</td>
                              <td className="text-center">{tr_done || "-"}</td>
                              <td className="text-center">
                                ${parseFloat(price || 0).toFixed(2)}
                              </td>
                              <td className="text-right">{expiry || "-"}</td>
                              <td className="text-center">{balance || "-"}</td>
                              <td className="text-center">
                                ${parseFloat(outstanding || 0).toFixed(2)}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  ) : (
                    <div className="no-treatments-found">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                      >
                        <circle cx="11" cy="11" r="8" />
                        <path d="M21 21l-4.35-4.35" />
                      </svg>
                      <p>No treatment packages found</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  basicApptDetail: state.appointment.basicApptDetail,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
      commonCreateApi,
      commonPatchApi,
      commonUpdateApi,
    },
    dispatch
  );
};

export const AppointmentForm = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(AppointmentFormClass)
);
